module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "defauleMenu"
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("查询默认配置项")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "80px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%",
      "margin-right": "30px"
    },
    attrs: {
      "label": "配置项名称:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formLabelAlign.name),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formLabelAlign.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "配置项编码:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formLabelAlign.number),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "number", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formLabelAlign.number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.clearForm()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.queryFrom()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("配置项信息")])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.configureInfo,
      "highlight-current-row": "",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "position",
      "label": "配置项位置",
      "width": "220",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modular",
      "label": "配置项所在模块",
      "width": "250",
      "sortable": "",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "配置项名称",
      "width": "250",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "infoNumber",
      "label": "配置项编码",
      "width": "250",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("\n            更多操作"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "配置项位置:",
      "prop": "position"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.position),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "position", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.position"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "配置项所属模块:",
      "prop": "modular"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.modular),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "modular", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.modular"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "配置项名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label": "配置项编码:",
      "prop": "infoNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editForm.infoNumber),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "infoNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.infoNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置项内容:",
      "prop": "configureContact"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.configureContact),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "configureContact", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.configureContact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "remarks", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateData
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-3296f78e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configureManagement/defaultMenu.vue
// module id = 1624
// module chunks = 0